import { defineComponent as _defineComponent } from 'vue'
export interface Item {
  label: string;
  icon: IconDefinition;
  variant?: 'danger' | 'info' | 'warning' | 'success';
  fn: () => void;
}

/**
 * `FlyoutMenu` component properties.
 */
export interface Props {
  x: number;
  y: number;
  items: Item[];
}

/** `FlyoutMenu` component emits. */
export type Emits = (event: 'before-remove' | 'after-remove') => void;


import { ref, computed, onMounted, onUnmounted } from 'vue';

import { delay } from '@tools/delay';
import { randomId } from '@tools/random-id';

import Icon, { IconDefinition } from '@components/Icon.vue';

const __default__ = { name: 'FlyoutMenu' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    x: null,
    y: null,
    items: null
  },
  emits: ["before-remove", "after-remove"],
  setup(__props: any, { expose, emit }: { emit: ((event: 'before-remove' | 'after-remove') => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  x: number;
  y: number;
  items: Item[];
};

/**
 * Flyout menu item.
 */




expose({ close });

const el = ref<HTMLDivElement | null>(null);

const active = ref(true);
const xOffset = ref(-10);

const style = computed(() => {
  const x = props.x - xOffset.value;
  const y = props.y;

  return { transform: `translate(${x}px, ${y}px)` };
});

/** Keyed flyout menu items. */
const menuItems = computed(() => {
  return props.items.map((item) => ({ key: randomId(), ...item }));
});

onMounted(() => {
  const flyoutWidth = el.value?.offsetWidth ?? 0;
  const widthDifference = window.innerWidth - props.x - flyoutWidth - 20;

  if (widthDifference < 0) {
    xOffset.value = flyoutWidth + 10;
  }

  delay().finally(() => {
    document.addEventListener('click', onCloseEvent);
    document.addEventListener('wheel', onCloseEvent);
  });
});

onUnmounted(() => {
  document.removeEventListener('click', onCloseEvent);
  document.removeEventListener('wheel', onCloseEvent);
});

/**
 * Execute a menu item action. Emits event `action`.
 */
function execAction(fn: Item['fn']) {
  fn();

  close();
}

/**
 * Manually close the flyout menu.
 */
function close() {
  active.value = false;
}

function onCloseEvent({ target }: Event) {
  if (
    target instanceof Node &&
    (el.value === target || el.value?.contains(target))
  ) {
    return;
  }

  close();
}

function beforeLeave() {
  emit('before-remove');
}

function afterLeave() {
  emit('after-remove');
}

return { __sfc: true,props, emit, el, active, xOffset, style, menuItems, execAction, close, onCloseEvent, beforeLeave, afterLeave, Icon }
}

})